import React from "react";

import OverviewCard from "./Components/OverviewCard";
import AlertSection from "./Components/AlertSection";
import PaymentsListCard from "./Components/PaymentsListCard";

import { usePaymentsManagement } from "./hooks/payments-hooks";
import { PaymentProvider } from "./hooks/payments-context";

const PaymentsTab = ({ formik }) => {
  const {
    getTotalPayments,
    addPayment,
    handlePaymentTypeChange,
    handlePaymentDateChange,
    handleUnitAmountChange,
    handlePaymentStatusChange,
    getPaymentTotal,
    deletePayment,
    handleVATChange,
    getTotalSettlementPrice,
    calculatePaymentPercentages
  } = usePaymentsManagement(formik);

  const { 
    totalPaidPercentage, 
    remainingPercentage 
  } = calculatePaymentPercentages();

  return (
    <PaymentProvider 
      initialPayments={formik.values.payments}
      onUpdatePayments={(updatedPayments) => {
        formik.setFieldValue("payments", updatedPayments);
      }}
    >
      <div className="container-fluid px-4 py-3" style={{maxWidth:"1500px"}}>
        {/* Overview Card */}
        <OverviewCard 
          formik={formik}
          getTotalPayments={getTotalPayments}
          handleVATChange={handleVATChange}
          totalPaidPercentage={totalPaidPercentage}
          getTotalSettlementPrice={getTotalSettlementPrice}
        />
        
        {/* Alerts */}
        <AlertSection 
          formik={formik}
          getTotalPayments={getTotalPayments}
        />
        
        {/* Payments List Card */}
        <PaymentsListCard 
          formik={formik}
          addPayment={addPayment}
          handlePaymentTypeChange={handlePaymentTypeChange}
          handlePaymentDateChange={handlePaymentDateChange}
          handleUnitAmountChange={handleUnitAmountChange}
          handlePaymentStatusChange={handlePaymentStatusChange}
          getPaymentTotal={getPaymentTotal}
          deletePayment={deletePayment}
          payments={formik.values.payments}
          settledPrice={formik.values.settled_price}
        />
      </div>
    </PaymentProvider>
  );
};

export default PaymentsTab;